'use client';
import {
    isTFilterGroupFromToProps,
    isTFilterGroupRangeProps,
    TFilterGroupProps,
} from '@/components/filters/filter-group/filter-group.component.types';
import FilterGroupSlider from '@/components/filters/filter-group/filter-group-slider.component';
import FilterGroupOther from '@/components/filters/filter-group/filter-group-other.component';
import FilterGroupFromTo from '@/components/filters/filter-group/filter-group-from-to.component';

const FilterGroup = (props: TFilterGroupProps) => {
    return (
        <>
            {isTFilterGroupRangeProps(props) && (
                <FilterGroupSlider {...props} />
            )}
            {isTFilterGroupFromToProps(props) && (
                <FilterGroupFromTo {...props} />
            )}
            {!isTFilterGroupRangeProps(props) &&
                !isTFilterGroupFromToProps(props) && (
                    <FilterGroupOther {...props} />
                )}
        </>
    );
};

export default FilterGroup;
